<template>
    <div>
        <span style="display: inline-block; font-size: 32px; position: relative; top: -8px" class="mr-4">MÉDIA: </span>

            <star-rating
                style="display: inline-block"
                :increment="0.05"
                active-color="#EA5455" 
                inactive-color="#f6dadb"
                :show-rating="false" 
                :rating="averageRating" 
                :read-only="true" 
                :star-size="50"></star-rating>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import StarRating from 'vue-star-rating'

    export default {
        components : {
            StarRating
        },

        data () {
            return {
                
            }
        },
        
        computed : {
            ...mapGetters('ratings', ['averageRating'])
        },
    }
</script>